import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import ContextMenu from '../ContextMenu';
import CardDetail from '../ContextMenu/CardDetail';
import ConfirmButton from '../ConfirmButton';
import PowerButtons from '../Powers/PowerButtons';
import DiscardFromPlayButton from '../Trainer/DiscardFromPlayButton';
import { BENCH } from '../ActiveGame/contextMenuTypes';
import { selectActivePokemon, selectBench, selectOptions, selectPlayer } from '../ActiveGame/selectors';
import { putActivePokemon, switchIn } from '../Pokemon/actions';
import { selectActiveBenchPosition, selectPuttingActive, selectSwitchingIn } from '../Pokemon/selectors';

const BenchContextMenu = ({ userId }) => {
  const dispatch = useDispatch();
  const activePokemon = useSelector((state) => selectActivePokemon(state, { userId }));
  const activeBenchPosition = useSelector(selectActiveBenchPosition);
  const bench = useSelector((state) => selectBench(state, { userId }));
  const player = useSelector(selectPlayer);
  const puttingActive = useSelector(selectPuttingActive);
  const switchingIn = useSelector(selectSwitchingIn);
  const options = useSelector(selectOptions);

  const benchCard = bench && bench.get('cards').find(card => card.get('order') === activeBenchPosition);

  if (!benchCard) {
    return null;
  }

  const mine = userId === player.getIn(['user', 'id']);
  const name = benchCard.get('name', 'Benched Pokémon');

  return (
    <ContextMenu menu={BENCH} userId={userId} title={mine ? name : `Opponent's ${name}`}>
      <CardDetail
        card={benchCard}
        damage={benchCard.get('damage')}
        trainers={benchCard.get('trainers')}
        energyAttachments={benchCard.get('energyAttachments')}
      >
        {mine && !activePokemon && <ConfirmButton
          onConfirm={() => dispatch(putActivePokemon(benchCard.get('order')))}
          disabled={puttingActive}
          prompt={`Make ${name} your active Pokémon?`}
          primary
        >
          Make active
        </ConfirmButton>}
        {mine && activePokemon && <PowerButtons card={benchCard} at={benchCard.get('order')} />}
        {mine && <DiscardFromPlayButton at={benchCard.get('order')} name={name} />}
        {/* Whirlwind hit your active Pokémon: the server says when you owe this pick. */}
        {mine && activePokemon && options && options.get('switch_in') === true && <ConfirmButton
          onConfirm={() => dispatch(switchIn(benchCard.get('order')))}
          disabled={switchingIn}
          prompt={`Switch ${name} in for ${activePokemon.getIn(['card', 'name'], 'your active Pokémon')}?`}
          primary
        >
          Switch in
        </ConfirmButton>}
      </CardDetail>
    </ContextMenu>
  );
};

BenchContextMenu.propTypes = {
  userId: PropTypes.number.isRequired,
};

export default BenchContextMenu;
